<template>
  <div class="lh_container">
    <v-p-top @showResult="onShowResult"
             @end="handle_end"
             :phase="phase"
             :next_phase="next_phase"
             :open_time="open_time"
             :records="records"
             :name="head.title"
             :remain_time="remain_time"
             :block_time="block_time"
             @change="changeFp"
    >
      <ul slot="recodeNumber" class="num_record lh_num_record">
        <li v-for="(item, index) in records" :key="'re' + index" class="item lh_item" :style="{ 'width': index==6 ? '60px' : '' }">
          <span v-if="index==6">+</span>
          <span class="number" :class="filterNumberColor(item.number)">{{ item.number }}</span>
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </v-p-top>

    <template v-if="!$route.query.notice">
      <v-tab class="page-tabs" v-if="tabs.length" :current="tabs[curTab].value" @onChangeTab="onLHTabChange"
             :tabs="tabs"
             :border="true"></v-tab>

      <div class="lh-main page-wrapper" :style="contentStyleObj">

        <!--<v-c-input @again="handle_again" class="c-input" v-model="chip" @certain="certain_handle"
                   @reset="reset_selected"
                   @onQuickCreate="handleQuickCreate"
        />-->

        <!-- inner-tab -->
        <component :chip="chip.toString()" ref="c_model_input" :is="componentsName" class="component-page"
                   :data="tabPageData"
                   :current="current"
                   @reset="reset_selected"
                   @onRestValue="onRestValue"
        ></component>
        <!-- inner-tab end -->

        <v-c-input @again="handle_again" class="c-input" v-model="chip" @certain="certain_handle"
                   @reset="reset_selected"
                   @onQuickCreate="handleQuickCreate"
        />

        <v-statistic @showRule="onShowRule" class="page-side" @onQuickCreate="handleQuickCreate"></v-statistic>

        <!-- 最近8期开奖记录 -->
        <div class="recent-draws">
          <div class="recent-draws-header">
            <span class="recent-draws-title">{{ head.title }}</span>
            <label class="recent-draws-toggle">
              <input type="checkbox" v-model="showRecentDraws" /> 最近8期开奖
            </label>
          </div>
          <template v-if="showRecentDraws">
            <table class="recent-draws-table" v-if="recentDrawList.length">
              <thead>
                <tr>
                  <th></th>
                  <th>日期</th>
                  <th>期数</th>
                  <th>球1</th><th>球2</th><th>球3</th><th>球4</th><th>球5</th><th>球6</th>
                  <th>特码</th>
                  <th>生肖</th>
                  <th>总和</th>
                  <th>一肖量</th>
                  <th>尾数量</th>
                  <th>特码单双</th>
                  <th>特码大小</th>
                  <th>合数单双</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in recentDrawList" :key="'rd-'+idx">
                  <td>{{ idx + 1 }}</td>
                  <td>{{ row.drawDate }}</td>
                  <td>{{ row.period }}</td>
                  <td v-for="(ball, bi) in row.balls" :key="'b-'+bi">
                    <span class="rd-ball" :class="filterNumberColor(ball)">{{ ball }}</span>
                  </td>
                  <td>
                    <span class="rd-ball" :class="filterNumberColor(row.special)">{{ row.special }}</span>
                  </td>
                  <td>{{ row.sxList }}</td>
                  <td :class="row.sumClass">{{ row.sum }}</td>
                  <td>{{ row.sxCount }}</td>
                  <td>{{ row.wsCount }}</td>
                  <td :class="row.tmDanShuangClass">{{ row.tmDanShuang }}</td>
                  <td :class="row.tmDaXiaoClass">{{ row.tmDaXiao }}</td>
                  <td :class="row.hsDanShuangClass">{{ row.hsDanShuang }}</td>
                </tr>
              </tbody>
            </table>
            <div v-else class="recent-draws-empty">暂无记录</div>
          </template>
        </div>

      </div>
      <order ref="order" @submit="order_sub" :orders="orders" :order_subing="order_subing"/>
    </template>
  </div>
</template>

<script>
import methods from '../methods';
import objectPath from 'object-path';
import { mapState, mapActions } from 'vuex';
import Order from '../../../components/dialog/order';
import VPTop from '../../../components/c_top';
import VSelect from '../../../components/c_select';
import VStatistic from '../../../components/c_statistics';
import VTab from '../../../components/c_tab';
import VCInput from '../../../components/c_a-input';
import DH110 from '../../../components/pageComponents/lh/dh1-10';
import GYH from '../../../components/pageComponents/lh/gyh';
import GYZH from '../../../components/pageComponents/lh/gyzh';
import TAB from '../../../components/pageComponents/lh/tab';
import BANBO from '../../../components/pageComponents/lh/banbo';
import ZONGXIAO from '../../../components/pageComponents/lh/zongxiao';
import TEXIAOSHOUWEI from '../../../components/pageComponents/lh/texiaoshouwei';
import eventMixin from '../../../utils/eventMixin';
import { computedDataLH } from '../../../utils/lhComputed';
import { filterNumber } from "../../../utils/objectFactory";
import { getLotteryResults } from '../../../service/lottery';

const each = (cb, el) => {
  (el.name === 'g_input_selected_item' || el.name === 'g_input_selected_item_type_2') && cb(el);
  if (el.$children.length > 0) el.$children.forEach(child => each(cb, child));
};

export default {
  name: "lh",
  mixins: [eventMixin, methods],
  components: {
    Order,
    VTab,
    VPTop,
    VSelect,
    VCInput,
    VStatistic,
    DH110,
    TAB,
    GYH,
    GYZH,
    BANBO,
    ZONGXIAO,
    TEXIAOSHOUWEI
  },
  computed: {
    // 封盘倒计时
    remain_time() {
      return this.lottery.next_info.remain_time;
    },
    block_time() {
      return this.lottery.next_info.block_time;
    },
    next_phase() {
      return this.lottery.next_info.period;
    },
    open_time() {
      return this.lottery.next_info.open_time || '';
    },
    // 期数
    phase() {
      return this.lottery.latest_result.period;
    },
    /*have_next() {
      return this.lottery.next_info.have_next;
    },*/
    // 开奖号码
    records() {
      const number = objectPath.get(this.lottery, 'latest_result.number');
      const shengxiao = objectPath.get(this.lottery, 'latest_result.shengxiao');
      const DEFAULT_DATA = [];
      if (number) {
        const DEFAULT_SHENGXIAO = shengxiao.split(',');
        number.split(',').forEach((item, index) => {
          const value = objectPath.get(DEFAULT_SHENGXIAO, `${index}`);
          DEFAULT_DATA.push({
            number: item,
            value
          })
        });
      }
      return DEFAULT_DATA;
    },
    ...mapState({
      curTab: state => state.home_PK10.curTab,
      headTabs: state => state.home.headTabs,
      tabs: state => state.home_PK10.tabs,
      odds: state => state.home_PK10.odds,
      lottery: state => state.home_PK10.lottery,
      order_history: state => state.home_PK10.order_history,
      longQueue: state => state.home.longQueue,
      playTypeRadio: state => state.home.playTypeRadio,
      playDantuoTotal: state => state.home.playDantuoTotal,
      shengxiaoData: state => state.home_PK10.shengxiaoData,
      statistics: state => state.home.statistics,
    }),
    current() {
      return this.tabs[this.curTab] || null;
    },
    head() {
      return this.headTabs.find(item => item.lottery_type == this.$route.query.lottery_type) || {};
    },
    // 组件名称
    componentsName() {
      let _name = 'g-y-z-h';
      const value = objectPath.get(this.current, 'value');
      switch (value) {
        case 1:
        case 2:
        case 3:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 11:
        case 12:
        case 13:
          _name = 't-a-b';
          break;
        // 特肖首尾
        case 4:
          _name = 't-e-x-i-a-o-s-h-o-u-w-e-i';
          break;
        // 总肖
        case 10:
          _name = 'z-o-n-g-x-i-a-o';
          break;
        // 半波
        case 14:
        case 15:
          _name = 'b-a-n-b-o';
          break;
      }
      return _name;
    },
    tabPageData() {
      const odds = this.odds.map(item => {
        if (!item._status) item._status = item.status;
        if (!this.time) {
          item.status = 3;
        } else if (item.status === 3) {
          item.status = item._status;
        }
        return item;
      });
      const data = computedDataLH(odds, this.current, this.shengxiaoData, this.playTypeRadio);
      return data;
    },
    recentDrawList() {
      if (!this.recentDrawsRaw || !this.recentDrawsRaw.length) return [];
      return this.recentDrawsRaw.map(item => {
        var dr = item.draw_results || [];
        var balls = dr.slice(0, 6);
        var special = dr[6] || '';
        var sxArr = dr.slice(7) || [];
        var sxUnique = [...new Set(sxArr)];
        var wsArr = balls.concat([special]).map(n => parseInt(n) % 10);
        var wsUnique = [...new Set(wsArr)];
        var sum = item.sum || {};
        var sp = item.special || {};
        var dt = (item.draw_time || '').replace(/\s.*/, '');
        var weekDay = '';
        try {
          var d = new Date(item.draw_time);
          weekDay = ['日','一','二','三','四','五','六'][d.getDay()];
        } catch(e) {}
        var colorCls = function(v) {
          if (!v) return '';
          if (v === '大' || v === '双' || v === '合大' || v === '合双') return 'rd-red';
          return 'rd-blue';
        };
        return {
          period: item.period,
          shortPeriod: String(item.period).slice(-3),
          drawDate: dt + (weekDay ? ' (周' + weekDay + ')' : ''),
          balls: balls,
          special: special,
          sxList: sxArr.join('+'),
          sum: sum.sum,
          sumClass: '',
          sxCount: sxUnique.length,
          wsCount: wsUnique.length,
          tmDanShuang: sp.danShuang || '',
          tmDanShuangClass: colorCls(sp.danShuang),
          tmDaXiao: sp.daXiao || '',
          tmDaXiaoClass: colorCls(sp.daXiao),
          hsDanShuang: sp.heShuDanShuang || '',
          hsDanShuangClass: colorCls(sp.heShuDanShuang),
        };
      });
    }
  },
  data() {
    return {
      origin_list: null,
      orders: [],
      order_subing: false,
      curInnerTab: 0,
      chip: '',
      time: 0,
      contentStyleObj: {
        height: ''
      },
      showRecentDraws: true,
      recentDrawsRaw: [],
    }
  },
  methods: {
    ...mapActions({
      createOrder: 'home_PK10/createOrder',
      getNewLotteryRes: 'home_PK10/getNewLotteryRes',
      updateUserInfo: 'root/updateUserInfo',
      getLotteryLatest: 'home/getLotteryLatest',
      getLongQueue: 'home/getLongQueue',
      getStatistics: 'home/getStatistics',
      onSetLhItemTotal: 'home/onSetLhItemTotal',
    }),
    ...mapActions("table", {
      load_lh_shengxiao: "load_lh_shengxiao"
    }),
    // 切换玩法
    onLHTabChange(tab) {
      this.$store.dispatch("home_PK10/setPlayedName", '');
      this.onTabChanged(tab);
    },
    onRestValue() {
      this.$store.state.inputnum = '';
      this.$emit("input", "");
    },
    getHeight() {
      //this.contentStyleObj.height = window.innerHeight - 220 + 'px';
    },
    filterNumberColor(checkNumber) {
      const isFilterNumber = filterNumber(checkNumber);
      if (isFilterNumber) {
        return isFilterNumber;
      }
      return '';
    },
    loadRecentDraws() {
      var lt = this.$route.query.lottery_type;
      if (!lt) return;
      this.recentDrawsRaw = [];
      getLotteryResults({ lottery_type: lt, limit: 8, offset: 0 }).then(info => {
        if (info.result === 'ok' && info.data && info.data.records) {
          this.recentDrawsRaw = info.data.records;
        }
      }).catch(() => {});
    },
  },
  watch: {
    '$route.query.lottery_type': {
      handler() { this.loadRecentDraws(); },
      immediate: true
    }
  },
  created() {
    var lett = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        if (lett.$refs.order.showOrderDialog === true) {
          lett.$refs.order.handle_submit();
        } else {
          lett.certain_handle();
        }
      }
    }

    window.addEventListener('resize', this.getHeight);
    this.getHeight();
    // this.load_lh_shengxiao();
  },

}
</script>

<style scoped lang="stylus">
.lh_container
  .s_game-center
    margin-top 4px
    background-color #ffffff

.lh_num_record {
  display: inline-flex;
  vertical-align: top;

  .lh_item {
    display: flex;
    align-items: center;
    width: 50px;
    margin-left: 0px !important;
  }

  .number {
    width: 30px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: contain;
    font-size: 13px;
    font-weight: bold;
    padding-bottom: 2px;
  }

  .number-blue {
    color:#0b0c0c;
    background: url('../../../assets/back_blue.png') no-repeat center center;
  }

  .number-green {
    color:#0b0c0c;
    background: url('../../../assets/back_green.png') no-repeat center center;
  }

  .number-red {
    color:#0b0c0c;
    background: url('../../../assets/back_red.png') no-repeat center center;
  }
}

.recent-draws {
  margin-top: 2px;
  margin-right: -230px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 3px;
  clear: both;
  position: relative;
  z-index: 1;
}
.recent-draws-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: #f0f0f0;
  border-bottom: 1px solid #ddd;
  font-size: 13px;
}
.recent-draws-title {
  font-weight: bold;
  color: #333;
}
.recent-draws-toggle {
  font-size: 12px;
  color: #666;
  cursor: pointer;
  user-select: none;
}
.recent-draws-toggle input {
  margin-right: 4px;
  vertical-align: middle;
}
.recent-draws-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  text-align: center;
}
.recent-draws-table th {
  background: #f8f8f8;
  border: 1px solid #ddd;
  padding: 4px 3px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}
.recent-draws-table td {
  border: 1px solid #e6e6e6;
  padding: 3px 2px;
  white-space: nowrap;
}
.recent-draws-table tbody tr:hover {
  background: #f5f7fa;
}
.rd-ball {
  display: inline-block;
  width: 26px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  background-size: contain;
}
.rd-ball.number-red {
  color: #0b0c0c;
  background: url('../../../assets/back_red.png') no-repeat center center;
  background-size: contain;
}
.rd-ball.number-blue {
  color: #0b0c0c;
  background: url('../../../assets/back_blue.png') no-repeat center center;
  background-size: contain;
}
.rd-ball.number-green {
  color: #0b0c0c;
  background: url('../../../assets/back_green.png') no-repeat center center;
  background-size: contain;
}
.rd-red {
  color: #e00;
}
.rd-blue {
  color: #009;
}
.recent-draws-empty {
  text-align: center;
  padding: 20px 0;
  color: #999;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/lh/index.vue